import WaldoSpeechBubble from './WaldoSpeechBubble';

export default WaldoSpeechBubble;
